<template>
<div>
    <b-tabs card pills lazy>
        <b-tab :title="$t('Customers')">
            <users/>
        </b-tab>
        <b-tab :title="$t('Tariffs')">
            <tariffs/>
        </b-tab>
        <b-tab :title="$t('Parametrs')" >
          <settings/>
        </b-tab>
    </b-tabs>
</div>
</template>

<script>
import subscriptions from './subscriptions'
import users from './users'
import tariffs from './tariffs'
import settings from './settings'

export default {
  components: {
    users,
    tariffs,
    settings,
    subscriptions
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/customerPortal/24tv/main.vue